import { Provider } from "../../../classes/provider/Provider";

const dropboxProvider = new Provider({
	id: "dropbox",
	name: "Dropbox",
	description:
		"Dropbox is a file hosting service that offers cloud storage, file synchronization, personal cloud, and client software.",
	websiteHomeUrl: "https://dropbox.com/",
	websiteSupportUrl: "https://www.dropbox.com/help",
	iconUrl:
		"https://storage.googleapis.com/cdn.version2.io/providers/dropbox.png",
	color: "#0061fe",
});

export default dropboxProvider;
